import {
  getCurrentFields as getCompletionReviewFields,
  COMPLETION_REVIEW,
} from 'AppSrc/core/components/view-crq-screen/view-crq-completion-review';
import {
  getCurrentFields as getSectionOneFields,
  CHANGE_TYPE,
} from '../section-one/section-one';
import {
  getCurrentFields as getSectionTwoFields,
  CHANGE_QUESTIONS,
} from '../section-two/section-two';
import {
  getCurrentFields as getSectionThreeFields,
  START_AND_END_DATE,
} from '../section-three/section-three';
import {
  getCurrentFields as getSectionFourFields,
  CHANGE_DETAILS,
} from '../section-four/section-four';
import {
  getCurrentFields as getSectionFiveFields,
  WORK_INFORMATION_ITEMS,
} from '../section-five/section-five';
import {
  getCurrentFields as getReferencesSectionFields,
  REFERENCES_SECTION,
} from '../references-section/references-section';
import {
  getCurrentFields as getApproversSectionFields,
  APPROVERS_SECTION,
} from '../approvers-section/approvers-section';
import {
  getCurrentFields as getRelationshipsFields,
  RELATIONSHIPS,
} from '../relationships/relationships';

// Single source of truth for the method to retrieve current fields within create-crq,
const createCrqSectionGetCurrentFields = {
  [CHANGE_TYPE]: getSectionOneFields,
  [CHANGE_QUESTIONS]: getSectionTwoFields,
  [START_AND_END_DATE]: getSectionThreeFields,
  [CHANGE_DETAILS]: getSectionFourFields,
  [WORK_INFORMATION_ITEMS]: getSectionFiveFields,
  [REFERENCES_SECTION]: getReferencesSectionFields,
  [APPROVERS_SECTION]: getApproversSectionFields,
  [RELATIONSHIPS]: getRelationshipsFields,
  [COMPLETION_REVIEW]: getCompletionReviewFields,
};

export { createCrqSectionGetCurrentFields };

